<template>
  <div class="canvas" :id="flow" :ref="flow" @scroll="positionLine">
    <json-comp :json="flowJSON" v-show="showJSONComponent"></json-comp>
    <div class="nav">
      <div class="actions-title">
        <v-subheader>Actions</v-subheader>
      </div>
      <div class="list">
        <div id="audio" draggable="true" @dragstart="dragFlow($event)">
          <v-icon>{{ icon.audio }}</v-icon
          >Audio
        </div>
        <div id="menu" draggable="true" @dragstart="dragFlow($event)">
          <v-icon>{{ icon.menu }}</v-icon
          >Menu
        </div>
        <div id="sms" draggable="true" @dragstart="dragFlow($event)">
          <v-icon>{{ icon.sms }}</v-icon
          >SMS
        </div>
        <div id="voicemail" draggable="true" @dragstart="dragFlow($event)">
          <v-icon>{{ icon.voicemail }}</v-icon
          >Voice Mail
        </div>
        <div id="validation" draggable="true" @dragstart="dragFlow($event)">
          <v-icon>{{ icon.validation }}</v-icon
          >Validation
        </div>
        <div id="connection" draggable="true" @dragstart="dragFlow($event)">
          <v-icon>{{ icon.connection }}</v-icon
          >Connection
        </div>
        <div id="conference" draggable="true" @dragstart="dragFlow($event)">
          <v-icon>{{ icon.conference }}</v-icon
          >Conference
        </div>
        <div id="dial" draggable="true" @dragstart="dragFlow($event)">
          <v-icon>{{ icon.dial }}</v-icon
          >Dial
        </div>
        <!-- <div id="voicemail" draggable="true" @dragstart="dragFlow($event)">
                    <v-icon>{{ icon.voicemail }}</v-icon>Voicemail
                </div> -->
        <div id="hangup" draggable="true" @dragstart="dragFlow($event)">
          <v-icon>{{ icon.hangup }}</v-icon
          >Hangup
        </div>
      </div>

      <div class="upl_btn">
        <v-btn @click="putJSON()" style="background: #2194f3; color: white">
          Update
        </v-btn>
      </div>
    </div>
    <v-snackbar
      v-model="Snackbar.show"
      :bottom="true"
      :right="true"
      :timeout="Snackbar.timeout"
    >
      {{ Snackbar.text }}
      <v-btn color="pink" flat @click="Snackbar.show = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="alert" max-width="500px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title>
            <span class="headline">Alert! </span>
          </v-card-title>
        </v-toolbar>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-card-text text-bold>{{ alertmessage }}</v-card-text>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closealert()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" right top color="#fff">
      <span style="color: #000">Zoom: {{ zoomalert }}</span>
    </v-snackbar>
    <div class="scrolling-canvas" ref="scrollDiv" @scroll="positionLine()">
      <div
        id="div1"
        @drop="drop($event)"
        @dragover="allowDrop($event)"
        @click.stop="hideFooter($event)"
        class="zoom"
      >
        <slot name="flow"></slot>
        <vue-draggable-resizable
          v-for="(item, index) in shapes"
          :key="item.id"
          :min-width="150"
          :min-height="100"
          :w="item.w"
          :h="item.h"
          :x="item.x"
          :y="item.y"
          :class="{ check: true, highlight: item.showFooter }"
          class-name="flow"
          class-name-handle="custom-handle"
          :id="item.id"
          :ref="item.id"
          :draggable="item.draggable"
          :parent="true"
          @dragging="positionLine(index)"
          @resizing="positionLine(index)"
          @activated="activated(index, item)"
          @deactivated="item.showCircle = false"
          :active="item.showFooter"
        >
          <div
            draggable="true"
            class="connect-arrow"
            @dragstart.stop="drag($event, index)"
            @mouseenter="disableDrag"
            @mouseleave="enableDrag"
            id="drag"
            v-show="item.showCircle"
          ></div>
          <div
            draggable="true"
            class="connect-arrow-f"
            @dragstart.stop="drag($event, index)"
            @mouseenter="disableDrag"
            @mouseleave="enableDrag"
            id="drag-f"
            v-show="
              item.showCircle &&
              (item.name == 'menu' ||
                item.name == 'dial' ||
                item.name == 'validation')
            "
          ></div>
          <div
            class="content"
            :id="item.id"
            @drop="dropArrow(item.id, $event, index)"
            @dragover="allowDrop($event)"
          >
            <div :id="item.id" class="content__header">
              <div>{{ item.title }}</div>
              <div class="header-options">
                <v-icon
                  color="#fff"
                  style="font-size: 15px"
                  @click.stop="showFlowFooter(index)"
                  >edit</v-icon
                >
                <v-icon
                  color="#fff"
                  style="font-size: 15px"
                  v-if="item.data != 'trigger'"
                  @click.stop="removeFlow(index, item)"
                  >close</v-icon
                >
              </div>
            </div>
            <div :id="item.id" class="content__description">
              <div>
                <v-icon>{{ icon[`${item.data}`] }}</v-icon>
                <span class="name">{{ item.name }}</span>
              </div>
              <div style="font-size: 10px">{{ item.id }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </vue-draggable-resizable>
      </div>
    </div>
    <v-btn fab samll fixed color="#2194f3" class="zoom-out" @click="zoomOut()">
      <v-icon color="#fff" light>mdi-minus</v-icon>
    </v-btn>
    <v-btn fab samll fixed color="#2194f3" class="zoom-in" @click="zoomIn()">
      <v-icon color="#fff" light>add</v-icon>
    </v-btn>
    <div
      v-for="(footer, index) in shapes"
      :key="`${index}_${footer.id}`"
      class="foot"
      v-show="footer.showFooter"
    >
      <v-tabs class="gradient-bg" dark v-model="props_tab_index">
        <v-tab href="#general">General</v-tab>
        <v-tab href="#settings" v-show="footer.data != 'hangup'"
          >Settings</v-tab
        >
        <v-tab href="#control" v-show="footer.data == 'menu'">Control</v-tab>
      </v-tabs>
      <div v-if="props_tab_index == 'general'" class="fix-height">
        <div>
          <div class="input">
            <label for="title">Title</label>
            <input
              v-model="footer.name"
              type="text"
              name="title"
              id="title"
              placeholder="Enter title text"
            />
          </div>
          <div class="input">
            <label for="desc">Description</label>
            <textarea
              placeholder="Enter description text"
              v-model="footer.description"
              name="desc"
              id="desc"
              cols="44"
              rows="5"
            ></textarea>
          </div>
        </div>
      </div>
      <div v-if="props_tab_index == 'control'" class="fix-height">
        <div class="menu-settings" v-show="footer.data == 'menu'">
          <div class="table-view-parallel">
            <table class="table">
              <thead>
                <tr>
                  <th>Next</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(key, i) in footer.settings.choices" :key="i">
                  <td>
                    <div class="input">
                      <input
                        width="50%"
                        display="inline"
                        v-model.number="footer.settings.keys[i]"
                        @input="
                          menuControl(footer.settings.keys[i], footer.id, i)
                        "
                        type="number"
                        id="key"
                      />
                    </div>
                  </td>
                  <td>
                    <v-select
                      :items="menuItems"
                      label="Components"
                      item-text="name"
                      item-value="value"
                      return-object
                      v-model="footer.settings.choices[i]"
                      @change="
                        checkValueExist(
                          footer.settings.choices[i],
                          footer.id,
                          i
                        )
                      "
                      persistent-hint
                    ></v-select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-if="props_tab_index == 'settings'" class="fix-height">
        <!-- <div class="dial-settings" v-show="footer.data == 'dial'">
                    {{footer.settings.dialType}}
                    <div class="input">
                        <label for="connection">Connection</label>
                        <selectcomponent text="name" value="value" :list="connections" :select="footer.settings.connection" @update="updateTriggerConnection" :alwaysopenlist="false" :maxSelectable="1" placeholder="Select Connection"></multiselectcomponent>
                    </div>
                    <div class="input">
                        <label for="type">Dial Type</label>
                        <multiselectcomponent text="name" value="value" :list="type" :select="footer.settings.type" @update="updateTriggerType" :alwaysopenlist="false" :maxSelectable="1" placeholder="Select Type"></multiselectcomponent>
                    </div>
                    <div class="input">
                        <label for="desc">DID</label>
                        <input v-model="footer.settings.did" type="text" name="desc" id="desc" placeholder="DID" />
                    </div>
                </div> -->
        <div v-show="footer.data == 'dial'">
          <div class="input">
            <label for="dial-type">Dial Type</label>
            <multi-select
              id="dial-type"
              :options="dialTypes"
              v-model="footer.settings.dialType"
              placeholder="Select Dial Type"
            ></multi-select>
          </div>
          <div class="input" v-if="footer.settings.dialType === 'Queue'">
            <label for="queue">Queue</label>
            <multi-select
              id="queue"
              :options="queueTypes"
              v-model="footer.settings.queue"
              placeholder="Select Queue"
            ></multi-select>
          </div>
          <div class="input" v-if="footer.settings.dialType === 'Number'">
            <label for="caller">Number</label>
            <v-select
              :items="dialVariables"
              v-model="footer.settings.DID"
              placeholder="Select Number"
            ></v-select>
          </div>
          <div class="input" v-if="footer.settings.DID === 'Others'">
            <label for="caller">Number</label>
            <input
              v-model="footer.settings.DIDNumber"
              type="text"
              name="caller"
              id="caller"
              placeholder="Enter Phone Number"
            />
          </div>
          <div class="input" v-if="footer.settings.dialType === 'Queue'">
            <v-autocomplete
              v-model="footer.settings.users"
              :items="userData"
              label="Choose Agent"
              persistent-hint
              item-text="user_name"
              key="user_name"
              return-object
              small
              multiple
              single-line
              :allow-overflow="false"
            >
            </v-autocomplete>
          </div>
        </div>
        <div v-show="footer.data == 'hangup'">
          <!-- <div class="input">
                    <label for="success">Success</label>
                    <multi-select
                        id="success"
                        :options="elements"
                        v-model="footer.settings.success"
                        placeholder="Select next"
                    ></multi-select>
                    </div>
                    <div class="input">
                    <label for="failure">failure</label>
                    <multi-select
                        id="failure"
                        :options="elements"
                        v-model="footer.settings.failure"
                        placeholder="Select next"
                    ></multi-select>
                    </div> -->
        </div>
        <div class="trigger-settings" v-show="footer.data == 'trigger'">
          <!-- <div class="input">
                        <label for="connection">Connection</label>
                        <multiselectcomponent text="name" value="value" :list="connections" v-model="footer.settings.connection" @update="updateTriggerConnection" :alwaysopenlist="false" :maxSelectable="1" placeholder="Select Connection"></multiselectcomponent>
                    </div>
                    <div class="input">
                        <label for="type">Type</label>
                        <multiselectcomponent text="name" value="value" :list="type" :select="footer.settings.type" @update="updateTriggerType" :alwaysopenlist="false" :maxSelectable="1" placeholder="Select Type"></multiselectcomponent>
                    </div> -->
          <div class="input">
            <label for="desc">DID</label>
            <input
              v-model="footer.settings.did"
              type="text"
              name="desc"
              id="desc"
              placeholder="Enter DID"
            />
          </div>
          <div class="input">
            <v-checkbox
              v-model="footer.settings.check_balance"
              label="Check Balance"
            ></v-checkbox>
          </div>
          <div class="input" v-if="footer.settings.check_balance">
            <label for="balance">Balance</label>
            <input
              v-model="footer.settings.balance"
              type="number"
              name="balance"
              id="balance"
              placeholder="Enter Balance"
            />
          </div>
        </div>
        <!-- <div v-show="footer.data == 'voicemail'">
                    <div class="input">
                        <label for="file">Voicemail</label>
                        <input @change="addFile" type="file" name="file" id="file" />
                    </div>
                </div> -->
        <div class="audio-settings" v-show="footer.data == 'audio'">
          <div class="input-view-parallel">
            <label style="font-size: 17px; padding: 10px">Type</label>
            <input
              type="radio"
              name="audioChooser"
              v-on:change="audioOptions"
              v-model="audioOption"
              value="upload_file"
            />
            <label style="font-size: 12px; padding: 5px">Upload File</label>
            <input
              type="radio"
              name="audioChooser"
              v-on:change="audioOptions"
              v-model="audioOption"
              value="choose_file"
            />
            <label style="font-size: 12px; padding: 5px">Choose File</label>
            <div class="input" v-if="audioUpload">
              <label for="file">Audio File</label>
              <input
                accept=".mp3,audio/*"
                @change="addFile"
                type="file"
                name="audio-audio_file"
                :id="footer.id"
              />
              <span
                v-if="footer.settings['audio']"
                style="font-size: x-small; color: #7c4dfe"
                >{{ footer.settings["audio"] }}</span
              >
            </div>
            <div class="input" v-if="audioChoose">
              <label for="file">Audio File</label>
              <v-select
                :items="audioFiles"
                v-model="audioFile"
                @input="audioFilesUpload(audioFile, footer.id)"
                placeholder="Select Audio File"
              ></v-select>
            </div>
            <div class="input">
              <v-checkbox
                v-model="footer.settings.expect"
                @change="checkDTMF(footer.settings.expect, footer.id)"
                label="Expect DTMF"
              ></v-checkbox>
            </div>
            <!-- <div class="input">
                        <label for="timeout">Timeout</label>
                        <input v-model.number="footer.settings.timeout" type="number" name="timeout" id="timeout" placeholder />
                        seconds
                    </div> -->
            <!-- <div class="input">
                        <label for="repeat">Repeat</label>
                        <input v-model.number="footer.settings.repeat" type="number" name="repeat" id="repeat" />
                        times
                    </div> -->
            <!-- <div class="input">
                        <v-checkbox v-model="footer.settings.skip" label="Skip on DTMF"></v-checkbox>
                    </div>
                    <div class="input">
                        <v-checkbox v-model="footer.settings.expect" label="Expect DTMF"></v-checkbox>
                    </div> -->
          </div>
        </div>
        <div class="vmail-settings" v-show="footer.data == 'voicemail'">
          <div class="input">
            <label for="vmail_num">Number</label>
            <input
              v-model="footer.settings.vmail_num"
              type="text"
              name="vmail_num"
              id="vmail_num"
              placeholder="Enter Phone Number"
            />
          </div>
        </div>
        <div class="sms-settings" v-show="footer.data == 'sms'">
          <div class="input">
            <label for="sms_opt">SMS</label>
            <multi-select
              id="sms_opt"
              :options="smsTypes"
              v-model="footer.settings.sms_opt"
              placeholder="Select Sms Option"
            ></multi-select>
          </div>
          <div class="input" v-if="footer.settings.sms_opt === 'Others'">
            <label for="sms_num">Number</label>
            <input
              v-model="footer.settings.sms_num"
              type="text"
              name="sms_num"
              id="sms_num"
              placeholder="Enter Phone Number"
            />
          </div>
          <div class="input">
            <label for="sms_txt">Message</label>
            <textarea
              v-model="footer.settings.sms_txt"
              name="sms_txt"
              id="sms_txt"
              cols="44"
              rows="5"
              placeholder="Type Your Message"
            ></textarea>
          </div>
          <div class="input">
            <label for="sms_api">SMS API</label>
            <input
              v-model="footer.settings.sms_api"
              type="text"
              name="sms_api"
              id="sms_api"
              placeholder="Enter API URL"
            />
          </div>
        </div>
        <div class="conference-settings" v-show="footer.data == 'conference'">
          <div class="input">
            <label for="conf_num">Bridge Number</label>
            <input
              v-model="footer.settings.conf_num"
              type="text"
              name="conf_num"
              id="conf_num"
              placeholder="Enter Phone Number"
            />
          </div>
        </div>
        <div class="validation-settings" v-show="footer.data == 'validation'">
        <div class="input">
            <label for="time_cond">Time Condition</label>
            <input
              v-model="footer.settings.time_from"
              type="time"
              name="time_from"
              id="time_from"
              placeholder="From"
            />
            <input
              v-model="footer.settings.time_to"
              type="time"
              name="time_to"
              id="time_to"
              placeholder="To"
            />
          </div> 
          <div class="input_table">
            <label for="validate_param">Validate</label>
            <table>
              <tr v-for="(key, i) in footer.settings.rules" :key="i">
                <td>
                  <v-select
                    v-model="footer.settings.rules[i].parameter"
                    :items="variables"
                    name="validate_param"
                    @change="
                      add_validate(
                        'param',
                        footer.id,
                        i,
                        footer.settings.rules[i].parameter
                      )
                    "
                    id="validate_param"
                    placeholder="Param"
                  />
                </td>
                <td>
                  <v-select
                    v-model="footer.settings.rules[i].operation"
                    :items="operations"
                    name="operation"
                    @change="
                      add_validate(
                        'opera',
                        footer.id,
                        i,
                        footer.settings.rules[i].operation
                      )
                    "
                    id="operation"
                    placeholder="Operation"
                  />
                </td>
                <td>
                  <input
                    v-model="footer.settings.rules[i].value"
                    type="text"
                    name="validate_value"
                    @change="
                      add_validate(
                        'value',
                        footer.id,
                        i,
                        footer.settings.rules[i].value
                      )
                    "
                    id="validate_value"
                    placeholder="Value"
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="connection-settings" v-show="footer.data == 'connection'">
          <div class="input">
            <label for="conn_method">Connection</label>
            <multi-select
              id="conn_method"
              :options="connMethods"
              v-model="footer.settings.conn_method"
              placeholder="Select Connection Method"
            ></multi-select>
          </div>
          <div class="input">
            <label for="conn_type">Type</label>
            <multi-select
              id="conn_type"
              :options="connTypes"
              v-model="footer.settings.conn_type"
              placeholder="Select Connection Type"
            ></multi-select>
          </div>
          <div class="input">
            <label for="conn_api">API</label>
            <input
              v-model="footer.settings.conn_api"
              type="text"
              name="conn_api"
              id="conn_api"
              placeholder="Enter API URL"
            />
          </div>
          <div class="input">
            <label for="conn_res">Response</label>
            <textarea
              @change="add_response(footer.id, footer.settings.conn_res)"
              v-model="footer.settings.conn_res"
              name="conn_res"
              id="conn_res"
              cols="44"
              rows="3"
              placeholder="Enter Response"
            ></textarea>
          </div>
          <div class="input_table">
            <label for="api_param">Parameters</label>
            <table>
              <tr v-for="(key, i) in footer.settings.api_param" :key="i">
                <td>
                  <input
                    v-model="footer.settings.api_param[i]"
                    type="text"
                    name="api_param"
                    @change="
                      add_params(
                        'key',
                        footer.id,
                        i,
                        footer.settings.api_param[i]
                      )
                    "
                    id="api_param"
                    placeholder="Key"
                  />
                </td>
                <td>
                  <v-select
                    v-if="valueDrop[i]"
                    v-model="footer.settings.api_value[i]"
                    :items="variables"
                    name="api_value"
                    @change="
                      add_params(
                        'value',
                        footer.id,
                        i,
                        footer.settings.api_value[i]
                      )
                    "
                    id="api_value"
                    placeholder="Value"
                  />
                  <input
                    v-if="valueText[i]"
                    v-model="footer.settings.api_value[i]"
                    type="text"
                    name="api_value"
                    @change="
                      add_params(
                        'value',
                        footer.id,
                        i,
                        footer.settings.api_value[i]
                      )
                    "
                    id="api_value"
                    placeholder="Value"
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="menu-settings" v-show="footer.data == 'menu'">
          <div class="input-view-parallel">
            <label style="font-size: 17px; padding: 10px">Type</label>
            <input
              type="radio"
              name="menuChooser"
              v-on:change="menuOptions"
              v-model="radioOption"
              value="upload_file"
            />
            <label style="font-size: 12px; padding: 5px">Upload File</label>
            <input
              type="radio"
              name="menuChooser"
              v-on:change="menuOptions"
              v-model="radioOption"
              value="choose_file"
            />
            <label style="font-size: 12px; padding: 5px">Choose File</label>
            <div class="check" v-if="menuUpload">
              <div class="input">
                <label for="file">Menu Audio File</label>
                <input
                  accept=".mp3,audio/*"
                  @change="addFile"
                  type="file"
                  name="menu-audio_file"
                  :id="footer.id"
                />
                <span
                  v-if="footer.settings.files"
                  style="font-size: x-small; color: #7c4dfe; padding: 3px"
                  >{{ footer.settings.files.menu_valid }}</span
                >
              </div>
              <div class="input">
                <label for="file">Invalid Audio File</label>
                <input
                  accept=".mp3,audio/*"
                  @change="addFile"
                  type="file"
                  name="menu-invalid_file"
                  :id="footer.id"
                />
                <span
                  v-if="footer.settings.files"
                  style="font-size: x-small; color: #7c4dfe; padding: 3px"
                  >{{ footer.settings.files.menu_invalid }}</span
                >
              </div>
            </div>
            <div class="check" v-if="menuChoose">
              <div class="input">
                <label for="file">Menu Audio File</label>
                <v-select
                  :items="audioFiles"
                  v-model="menuValid"
                  @input="menuFiles('valid', menuValid, footer.id)"
                  placeholder="Select Audio File"
                ></v-select>
              </div>
              <div class="input">
                <label for="file">Invalid Audio File</label>
                <v-select
                  :items="audioFiles"
                  v-model="menuInvalid"
                  placeholder="Select Audio File"
                  @input="menuFiles('invalid', menuInvalid, footer.id)"
                ></v-select>
              </div>
            </div>
            <!-- <div class="input">
              <label for="file">Timeout Audio File</label>
              <input
                accept=".mp3,audio/*"
                @change="addFile"
                type="file"
                name="menu-timeout_file"
                :id="footer.id"
              />
              <span
                v-if="footer.settings['menu-timeout_file']"
                style="font-size: x-small; color: #1ac43c"
                >{{ footer.settings["menu-timeout_file"] }}</span
              >
            </div> -->
            <div class="input">
              <label for="file">Timeout (seconds)</label>
              <input
                v-model.number="footer.settings.timeout"
                type="number"
                name="repeat"
                id="repeat"
              />
            </div>
            <div class="input">
              <label for="file">Repeat (times)</label>
              <input
                v-model.number="footer.settings.repeat"
                type="number"
                name="repeat"
                id="repeat"
              />
            </div>
            <!-- <div class="input">
              <v-checkbox
                v-model="footer.settings.skip"
                label="Skip on DTMF"
              ></v-checkbox>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line
import VueDraggableResizable from "vue-draggable-resizable";
// import multiselectcomponent from "@/components/multiselect.vue";
import LeaderLine from "leader-line-vue";
import { mapGetters } from "vuex";
import { isNumber } from "util";
import JsonComp from "./json";
import api from "@/utils/axios-util";
export default {
  props: ["flow", "lines", "showJSON"],
  components: {
    JsonComp: JsonComp,
    "vue-draggable-resizable": VueDraggableResizable,
  },
  data() {
    return {
      presetLine: [
        { type: "l", site: 100 },
        { type: "v", site: 200 },
      ],
      width: 60,
      height: 60,
      x: 0,
      y: 0,
      props_tab_index: "general",
      tenant_code: "",
      icon: {
        dial: "call",
        audio: "fa-volume-up",
        trigger: "bolt",
        menu: "fa-th",
        sms: "fas fa-sms",
        voicemail: "fab fa-teamspeak",
        validation: "fas fa-check-circle",
        connection: "fa fa-random",
        conference: "fa fa-cc",
        hangup: "fas fa-phone-slash",
      },
      options: {
        dial: {
          queueType: "",
          queue: "",
        },
        // hangup: {
        //     success: "",
        //     failure: ""
        // },
        audio: {
          audio: "",
          timeout: "",
          repeat: "",
          // skip: false,
          // expect: true
        },
        voicemail: {
          vmail_num: "",
        },
        sms: {
          sms_opt: "",
          sms_num: "",
          sms_txt: "",
          sms_api: "",
        },
        validation: {
          rules: [
            {
              parameter: "",
              operation: "",
              value: "",
            },
          ],
          time_from: "",
          time_to: "",
        },
        connection: {
          conn_method: "",
          conn_type: "",
          conn_api: "",
          api_param: [],
          api_value: [],
        },
        conference: {
          conf_num: "",
        },
        trigger: {
          connection: "",
          type: "",
          did: "",
        },
        menu: {
          choices: [
            {
              key: 1,
              value: "",
            },
          ],
          keys: [1],
          files: {
            menu_valid: "",
            menu_invalid: "",
          },
        },
        // crm: {}
      },
      menuItems: [],
      connections: [
        { name: "Option 1", value: "option1" },
        { name: "Option 2", value: "option2" },
        { name: "Option 3", value: "option3" },
      ],
      type: [
        { name: "Inbound", value: "inbound" },
        { name: "Outbound", value: "outbound" },
      ],
      elements: ["trigger"],
      dialTypes: ["Queue", "Number"],
      queueTypes: ["Queue1", "Queue2"],
      smsTypes: ["Caller", "Agent", "Others"],
      connMethods: ["GET", "POST", "PUT", "DELETE"],
      connTypes: ["TEXT", "JSON", "XML", "Form-urlencoded"],
      variables: [],
      valueText: [false],
      valueDrop: [true],
      audioFiles: [],
      shapeCount: 1,
      shapes: [
        {
          id: `CTI-${this.flow.name}-trigger0`,
          data: "trigger",
          name: "trigger",
          x: 45,
          y: 18,
          w: 150,
          h: 100,
          title: "TRIGGER",
          description: "Description",
          draggable: true,
          showFooter: false,
          showCircle: false,
          settings: {
            connection: [],
            type: [],
            did: "",
          },
          next: {
            success: "",
            failure: "",
          },
        },
      ],
      operations: [
        "LIKE",
        "LIKE %...%",
        "NOT LIKE",
        "IN",
        "NOT IN",
        "IS NULL",
        "IS NOT NULL",
        "BETWEEN",
        "NOT BETWEEN",
        "=",
        ">",
        "<",
        ">=",
        "<=",
        "!=",
      ],
      line: [],
      radioOption: "",
      audioOption: "",
      audioChoose: false,
      audioUpload: false,
      menuUpload: false,
      menuChoose: false,
      menuValid: "",
      menuInvalid: "",
      audioFile: "",
      start: "",
      end: "",
      showCircle: false,
      showFooter: false,
      zoom: "",
      connectors: [],
      Snackbar: {
        show: false,
        timeout: 1000,
        text: "",
      },
      flowJSON: {},
      showJSONComponent: false,
      alert: false,
      alertmessage: "",
      lineColor: "#000",
      lineType: "success",
      currentFlow: 0,
      offsetX: 0,
      offsetY: 0,
      selectedFlow: 0,
      highlightedFlowIndex: -1,
      zoomProperties: {
        defaults: {
          chrome: {
            browser: "chrome",
            zoom: 100,
            default: 100,
            step: 10,
            suffix: "%",
            prefix: "",
            property: "zoom",
            min: 30,
            max: 200,
            unit: 1,
          },
          firefox: {
            browser: "firefox",
            zoom: 1,
            default: 1,
            step: 0.1,
            suffix: ")",
            prefix: "scale(",
            property: "MozTransform",
            min: 0.5,
            max: 2,
            unit: 100,
          },
        },
        current: {},
      },
      snackbar: false,
      activatedIndex: null,
      userData: [],
    };
  },
  created() {
    let scope = this;
    if (scope.updateJSON) {
      var json = JSON.stringify(scope.updateJSON);
      json = JSON.parse(json);
      scope.flow_id = json.flow_id;
      scope.renderFlow(json);
    }
  },
  mounted() {
    let scope = this;
    scope.tenant_code = localStorage.getItem("TenantCode");
    scope.findAudio();
    var json = JSON.stringify(scope.updateJSON);
    json = JSON.parse(json);
    scope.shapeCount = Object.keys(json.data.values).length + 1;
    scope.flow.name = json.name;
    var connections = json.data.connections;
    scope.variables = json.data.variable;
    scope.drawLines(connections);
    window.addEventListener("keyup", (e) => {
      if (e.key == "Delete") {
        if (scope.highlightedFlowIndex >= 0) {
          scope.removeLine(scope.highlightedFlowIndex);
        }
      } else if (e.key === "Escape") {
        if (scope.highlightedFlowIndex >= 0) {
          scope.unHighlightLine(scope.highlightedFlowIndex);
        }
      }
    });
    var isFirefox = typeof InstallTrigger !== "undefined";
    var isChrome =
      !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    // var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
    // var isSafari =
    //   /constructor/i.test(window.HTMLElement) ||
    //   (function(p) {
    //     return p.toString() === "[object SafariRemoteNotification]";
    //   })(
    //     !window["safari"] ||
    //       (typeof safari !== "undefined" && safari.pushNotification)
    //   );
    // var isIE = false || !!document.documentMode;
    // var isEdge = !isIE && !!window.StyleMedia;
    // var isBlink = (isChrome || isOpera) && !!window.CSS;
    let browser = "";
    if (isChrome) {
      browser = "chrome";
    } else if (isFirefox) {
      browser = "firefox";
    }
    if (browser !== "") {
      scope.zoomProperties.current = scope.zoomProperties.defaults[browser];
    }

    scope.$store
      .dispatch("queueManagement", { name: "", take: 100, skip: 0 })
      .then((response) => {
        if (response.data.statusCode === 200) {
          const qType = response.data.data;
          var qTypes = [];
          qType.forEach((q) => {
            qTypes.push(q.name);
          });
          scope.queueTypes = qTypes;
        }
      });
    scope.$store
      .dispatch("userManagement", { skip: 0, take: 100 })
      .then((response) => {
        if (response.data.statusCode === 200) {
          scope.userData = response.data.data.map((user) => {
            return {
              phone_number: user.user_phone_number,
              user_name: user.user_email,
            };
          });
        }
      });
  },

  updated() {
    let scope = this;
    scope.updateJSON.name = scope.flow.name;
  },
  methods: {
    closealert() {
      this.alert = false;
    },
    checkDTMF(bool, id) {
      let dtmf = id + ".dtmf";
      if (bool == true) {
        this.variables.push(dtmf);
      } else if (bool == false) {
        let index = this.variables.indexOf(dtmf);
        this.variables.splice(index, 1);
      }
    },
    add_response(id, value) {
      let var_len = this.variables.length;
      let temp = [];
      for (let j = 0; j < var_len; j++) {
        if (this.variables[j].indexOf(id) > -1) {
          temp.push(this.variables[j]);
        }
      }
      this.variables = this.variables.filter((name) => {
        return !temp.includes(name);
      });
      let values = value.split(",");
      for (let i = 0; i < values.length; i++) {
        let v = id + "." + values[i];
        this.variables.push(v);
      }
    },
    add_validate(typ, id, index, val) {
      var scope = this;
      if (typ == "param") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            if (shape.settings.rules[index] === undefined) {
              shape.settings.rules[index] = {
                parameter: "",
                operation: "",
                value: "",
              };
            }
            shape.settings.rules[index].parameter = val;
            let temp = {
              parameter: "",
              operation: "",
              value: "",
            };
            shape.settings.rules.push(temp);
          }
          return shape;
        });
      }
      if (typ == "opera") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.rules[index].operation = val;
          }
          return shape;
        });
      }
      if (typ == "value") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.rules[index].value = val;
          }
          return shape;
        });
      }
      console.log("OOO", scope.shapes);
    },
    add_params(typ, id, index, val) {
      var scope = this;
      if (val === "Others") {
        scope.valueDrop[index] = false;
        scope.valueText[index] = true;
      }
      if (val !== "" && val !== undefined && typ == "key") {
        scope.valueText.push(false);
        scope.valueDrop.push(true);
      }
      if (typ == "key") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.api_param[index] = val;
            shape.settings.api_param[index + 1] = "";
          }
          return shape;
        });
      }
      if (typ == "value") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.api_value[index] = val;
            shape.settings.api_value[index + 1] = "";
          }
          return shape;
        });
      }
    },
    checkValueExist(selectData, id, index) {
      //this function is used to prevent duplicate value in dropdown menu item in sitting tab
      var scope = this;
      scope.line.map((obj) => {
        if (id === obj.endLabel) {
          obj.setOptions({ startLabel: index });
        }
      });
      scope.shapes.map(function (shape) {
        if (shape.id == id) {
          for (let i = 0; i < shape.settings.choices.length; i++) {
            if (i != index && shape.settings.choices[i].value == selectData) {
              shape.settings.choices[i].value = "";
            }
          }
        }
        return shape;
      });
    },
    menuControl(data, id, key) {
      var scope = this;
      scope.shapes.map(function (shape) {
        if (shape.id == id) {
          shape.settings.choices[key].key = data;
        }
        return shape;
      });
    },
    renderFlow(json) {
      let scope = this;
      scope.shapes = [];
      scope.shapes[0] = json.data.start;

      var values = json.data.values;
      var keys = Object.keys(values);
      keys.forEach((element) => {
        scope.shapes.push(values[element]);
      });
      scope.shapes.forEach((shape) => {
        if (shape.name === "connection") {
          console.log("SSS", shape.settings.api_param);
          if (shape.settings.api_param.length > 0) {
            for (let j = 0; j < shape.settings.api_value.length; j++) {
              if (shape.settings.api_value[j] !== "") {
                // scope.variables.push(shape.settings.api_value[j]);
                scope.valueDrop.push(true);
              }
            }
          } else {
            shape.settings.api_param.push("");
          }
        } 
        // else if (shape.name === "audio" && shape.settings.expect) {
        //   let dtmf = shape.id + ".dtmf";
        //   scope.variables.push(dtmf);
        // }
        else if (
          shape.name === "validation" &&
          shape.settings.rules.length > 1
        ) {
          let temp = {
            parameter: "",
            operation: "",
            value: "",
          };
          shape.settings.rules.push(temp);
          // for (let k = 0; k < shape.settings.rules.length; k++) {
          //   if (shape.settings.rules[k].parameter !== "") {
          //     scope.variables.push(shape.settings.rules[k].parameter);
          //   }
          // }
        }
        return shape;
      });
    },
    drawLines(connections) {
      let scope = this;
      // let connection = [];
      for (let i = 0; i < connections.length; i++) {
        var start = connections[i].start;
        var end = connections[i].end;
        if (start.split("-")[2].substring(0, 4) == "menu" && end) {
          scope.menuItems.push(end);
        }
        var tempShape = scope.shapes;
        scope.lineColor = "#000";
        for (let i = 0; i < tempShape.length; i++) {
          if (tempShape[i].id == start && tempShape[i].next.success == end) {
            scope.lineColor = "#000";
          }
          if (tempShape[i].id == start && tempShape[i].next.failure == end) {
            scope.lineColor = "#f00";
          }
        }
        scope.line[i] = new LeaderLine.setLine(
          document.getElementById(start),
          document.getElementById(end),
          {
            path: "fluid",
            color: scope.lineColor,
            endPlus: "arrow3",
            size: 1.5,
            endLabel: end,
          }
        );
        this.line.splice(this.line.length, 1, this.line);
        let div = document.querySelector("#div1");
        let lines = document.querySelectorAll(".leader-line");
        lines.forEach((line, index) => {
          line.style.zoom = div.style.zoom;
          line.addEventListener("click", () => {
            this.highlightLine(index);
          });
        });
        this.$emit("addLine", this.line[i]);
      }
      this.line.pop();
      this.$refs.scrollDiv.scrollTo(50, 20);
      this.$refs.scrollDiv.scrollTo(0, 0);
      // scope.line.position();
      this.line.forEach((obj) => {
        obj.position();
      });
    },
    updateTriggerConnection() {},
    updateTriggerType() {},

    showFlowFooter(index) {
      this.shapes.forEach((shape, shapeIndex) => {
        if (index != shapeIndex) {
          shape.showFooter = false;
        }
      });
      this.shapes[index].showFooter = !this.shapes[index].showFooter;
    },
    positionLine(selectedFlow) {
      if (isNumber(selectedFlow)) {
        this.scrollPage(selectedFlow);
      }
      if (this.line) {
        this.line.forEach((currentLine) => {
          currentLine.position();
        });
      }
    },
    audioOptions() {
      if (this.audioOption == "choose_file") {
        this.findAudio();
        this.audioUpload = false;
        this.audioChoose = true;
      }
      if (this.audioOption == "upload_file") {
        this.audioChoose = false;
        this.audioUpload = true;
      }
    },
    audioFilesUpload(value, id) {
      this.shapes.forEach((shape) => {
        if (shape.id == id) {
          shape.settings.audio = this.tenant_code + "_" + value;
        }
      });
    },
    menuOptions() {
      if (this.radioOption == "choose_file") {
        this.findAudio();
        this.menuUpload = false;
        this.menuChoose = true;
      }
      if (this.radioOption == "upload_file") {
        this.menuChoose = false;
        this.menuUpload = true;
      }
    },
    findAudio() {
      var scope = this;
      let data = "Active";
      scope.$store.dispatch("FindAudio", data).then((response) => {
        var len = this.tenant_code.length;
        var datas = response.data.records;
        if (datas !== "" && datas !== undefined && datas !== null) {
          datas.forEach((element) => {
            scope.audioFiles.push(element["file_name"].substring(len + 1));
          });
        }
      });
    },
    scrollPage(index) {
      const flowId = this.shapes[index].id,
        flow = this.$refs[`${flowId}`],
        div = this.$refs[`${this.flow}`],
        flowBottom = flow[0].$el.getBoundingClientRect().bottom,
        flowRight = flow[0].$el.getBoundingClientRect().right,
        screenBottom = window.innerHeight,
        screenRight = window.innerWidth;
      if (screenBottom - flowBottom < 200) {
        div.scrollBy(0, 50);
        this.shapes[index].showFooter = false;
      } else if (screenBottom - flowBottom > 400) {
        div.scrollBy(0, -50);
      }
      if (screenRight - flowRight < 200) {
        div.scrollBy(50, 0);
      } else if (screenRight - flowRight > 500) {
        div.scrollBy(-50, 0);
      }
    },
    addFile(event) {
      // let selectedFile = event.target.files[0];
      // this.shapes[index].model.audioFile = selectedFile;
      // var scope = this;
      let selectedFile = event.target.files[0];
      if (selectedFile.size <= 5000000) {
        let attribute = event.target.attributes;
        let name = attribute.name.nodeValue;
        let id = attribute.id.nodeValue;
        let formData = new FormData();
        formData.append("file_name", selectedFile);
        formData.append("status", "Active");
        formData.append("description", name);
        api.defaults.headers["Content-Type"] = "multipart/form-data";
        api
          .post("/audio", formData)
          .then((response) => {
            api.defaults.headers["Content-Type"] = "application/json";
            const file_name = response.data.insert.file_name;
            this.shapes.map(function (shape) {
              if (shape.id == id) {
                if (name.split("-")[0] == "menu") {
                  if (name == "menu-audio_file") {
                    shape.settings.files.menu_valid = file_name;
                  }
                  if (name == "menu-invalid_file") {
                    shape.settings.files.menu_invalid = file_name;
                  }
                }
                if (name.split("-")[0] == "audio") {
                  shape.settings.audio = file_name;
                }
              }
            });
            var leng = this.tenant_code.length;
            if (name.split("-")[0] == "audio") {
              this.audioFile = file_name.substring(leng + 1);
            }
            if (name == "menu-audio_file") {
              this.menuValid = file_name.substring(leng + 1);
            }
            if (name == "menu-invalid_file") {
              this.menuInvalid = file_name.substring(leng + 1);
            }
            return response;
          })
          .catch((error) => {
            api.defaults.headers["Content-Type"] = "application/json";
            return error;
          });
        this.findAudio();
      } else {
        this.showSnackBar("File Size Must be Below 5MB");
      }
    },
    dragFlow(ev) {
      ev.dataTransfer.setData("text/html", ev.target.id);
      var crt = ev.target.cloneNode(true);
      crt.style.border = "1px dotted black";
      crt.style.width = "150px";
      crt.style.height = "100px";
      crt.style.borderRadius = "8px";
      document.body.appendChild(crt);
      ev.dataTransfer.setDragImage(crt, 0, 0);
    },
    disableDrag() {
      this.shapes.forEach((shape) => {
        shape.draggable = false;
      });
    },
    enableDrag() {
      this.shapes.forEach((shape) => {
        shape.draggable = true;
      });
    },
    drag(ev, index) {
      ev.stopPropagation();
      ev.dataTransfer.setData("text", "foo");
      this.start = ev.target.parentNode.id;
      let el = ev.target.id;
      if (el == "drag-f") {
        this.lineColor = "#f00";
        this.lineType = "failure";
      } else {
        this.lineColor = "#000";
        this.lineType = "success";
      }
      this.currentFlow = index;
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    dropArrow(id, ev, index) {
      try {
        let isDroppable = true,
          scope = this;
        const flow = this.shapes[this.currentFlow];
        this.shapes.forEach((shape) => {
          shape.showFooter = false;
          shape.draggable = true;
        });
        ev.preventDefault();
        this.end = ev.target.parentNode.id;
        this.line.forEach((line) => {
          let end = line.end.id,
            start = line.start.id;
          if (
            (start == this.end && end == this.start) ||
            (start == this.start && end == this.end)
          ) {
            isDroppable = false;
          }
          if (
            this.lineType == "success" &&
            flow.name != "menu" &&
            flow.next.success != ""
          ) {
            scope.alertmessage =
              "Only menu will create a multiple success event.";
            scope.alert = true;
            isDroppable = false;
          }
          if (this.lineType == "failure" && flow.next.failure != "") {
            scope.alertmessage = "Only allow one failure event each elements.";
            scope.alert = true;
            isDroppable = false;
          }
        });
        if (isDroppable) {
          if (this.start.split("-")[2].substring(0, 4) == "menu" && this.end) {
            this.menuItems.push(this.end);
          }
          let line = new LeaderLine.setLine(
            document.getElementById(this.start),
            document.getElementById(this.end),
            {
              path: "fluid",
              color: this.lineColor,
              endPlus: "arrow3",
              size: 1.5,
              endLabel: this.end,
            }
          );
          this.line.splice(this.line.length, 1, line);
          let div = document.querySelector("#div1");
          let lines = document.querySelectorAll(".leader-line");
          lines.forEach((line, index) => {
            // line.style.zoom = div.style.zoom;
            if (this.zoomProperties.current.browser == "chrome") {
              line.style.zoom = div.style.zoom;
            }
            if (this.zoomProperties.current.browser == "firefox") {
              line.style.zoom = div.style.zoom;
              line.style[this.zoomProperties.current.property] =
                this.returnZoom1(this.zoomProperties.current.zoom, 0);
            }
            line.addEventListener("click", () => {
              this.highlightLine(index);
            });
          });
          this.$emit("addLine", this.line);
          if (this.lineType == "success") {
            if (flow.next.success == "") {
              flow.next.success = this.shapes[index].id;
            } else {
              flow.next.success =
                flow.next.success + "," + this.shapes[index].id;
            }
          }
          if (this.lineType == "failure") {
            flow.next.failure = this.shapes[index].id;
          }
        }
      } catch (e) {
        console.log("Error:==>", e);
      }
    },
    drop(ev) {
      console.log("IN");
      // this function is used to drop only in grid area or (#div1)
      // EDITED BY ABDUL SUBHAN TO REMOVE UN WANTED ELEMENT
      var scope = this;
      var data = ev.dataTransfer.getData("text/html");
      var drp = [
        "audio",
        "menu",
        "dial",
        "hangup",
        "sms",
        "validation",
        "voicemail",
        "connection",
        "conference",
      ];
      if (data === "connection") {
        scope.options[data] = {
          conn_method: "",
          conn_type: "",
          conn_api: "",
          api_param: [""],
          api_value: [],
        };
      } else if (data === "validation") {
        scope.options[data] = {
          rules: [
            {
              parameter: "",
              operation: "",
              value: "",
            },
          ],
        };
      }
      console.log("S", scope.options[data]);
      for (var i = 0; i < drp.length; i++) {
        if (drp[i] == data) {
          const zoom = document.getElementById("div1").style.zoom || 100;
          const zoomInt = parseInt(zoom) / 100;
          ev.preventDefault();
          if (ev.target.id != "drag") {
            data = ev.dataTransfer.getData("text/html");
            if (data) {
              if (data !== "hangup" && !scope.elements.includes(data)) {
                scope.elements.push(data);
              }
              var flowName = scope.flow.name;
              var tempArray = flowName.split(" ");
              flowName = tempArray.join("");
              tempArray = flowName.split("-");
              flowName = tempArray.join("");
              scope.shapes.push({
                id: `CTI-${flowName}-${data}${scope.shapeCount}`,
                data: data,
                name: data,
                x: ev.offsetX / zoomInt,
                y: ev.offsetY / zoomInt,
                w: 150,
                h: 100,
                title: `${data.toUpperCase()}`,
                draggable: true,
                description: "Description",
                showFooter: false,
                showCircle: false,
                next: {
                  success: "",
                  failure: "",
                },
                settings: scope.options[data],
              });
              scope.shapeCount += 1;
            }
          }
        }
      }
    }, //////////////////END EDIT/////////////////////////////////
    activated(index, item) {
      // this function is used to get or chech the selected element is active or not
      // EDITED BY ABDUL SUBHAN IN MENU ITEM SELECTION
      this.shapes[index].showCircle = true;
      this.activatedIndex = index;
      this.selectedFlow = index;
      if (item.id.split("-")[2].substring(0, 4) == "menu") {
        if (item.id == this.shapes[index].id) {
          this.menuItems = [];
          var menu = item.next.success.split(",");
          let uniquemenu = [...new Set(menu)];
          for (var i = 0; i < uniquemenu.length; i++) {
            this.menuItems.push(uniquemenu[i]);
          }
          for (i = 0; i < menu.length; i++) {
            item.settings.choices[i] = menu[i];
          }
        }
      }
    },
    menuFiles(val, value, id) {
      if (val == "valid") {
        this.shapes.forEach((shape) => {
          if (shape.id == id) {
            shape.settings.files.menu_valid = this.tenant_code + "_" + value;
          }
        });
      }
      if (val == "invalid") {
        this.shapes.forEach((shape) => {
          if (shape.id == id) {
            shape.settings.files.menu_invalid = this.tenant_code + "_" + value;
          }
        });
      }
    },
    // ########################END#################
    // activated(id) {
    //   this.shapes[id].showCircle = true;
    //   this.selectedFlow = id;
    // },
    deActivated(id) {
      this.shapes[id].showFooter = false;
      this.shapes[id].showCircle = false;
    },
    hideFooter(e) {
      if (e.target.id == "div1") {
        this.shapes.forEach((shape) => {
          shape.showFooter = false;
        });
        this.line.forEach((line) => {
          line.outline = false;
        });
      }
    },
    removeFlow(flowIndex, item) {
      // this function is used to removeFlow or file name
      const scope = this;
      scope.shapes.map(function (shape) {
        if (shape.data == "menu") {
          const x = shape.settings.choices.indexOf(item.id);
          shape.settings.choices.splice(x, 1);
          shape.settings.keys.splice(x, 1);
          shape.showFooter = false;
        }
        return shape;
      });
      let deletedIndex;
      if (scope.line.length > 0) {
        scope.line.forEach((obj, index) => {
          const endId = obj.end.id;
          const startId = obj.start.id;
          if (
            startId == scope.shapes[flowIndex].id ||
            endId == scope.shapes[flowIndex].id
          ) {
            deletedIndex = index;
            scope.shapes.map((shape) => {
              if (shape.id === startId) {
                if (obj.color === "#000") {
                  let connections = shape.next.success.split(",");
                  connections.splice(connections.indexOf(endId), 1);
                  shape.next.success = connections.join(",");
                } else {
                  let connections = shape.next.failure.split(",");
                  connections.splice(connections.indexOf(endId), 1);
                  shape.next.failure = connections.join(",");
                }
              }
            });
            obj.remove();
            scope.$emit("removeLine", index);
          }
        });
        scope.line.splice(deletedIndex, 1);
      }
      scope.menuItems.splice(item.id, 1);
      scope.shapes.splice(flowIndex, 1);
    },
    highlightFlow(id) {
      document.getElementById(id).classList.add("hover");
    },
    unHighlightFlow(id) {
      document.getElementById(id).classList.remove("hover");
    },
    highlightLine(index) {
      this.line.forEach((line) => {
        line.setOptions({
          dash: false,
          size: 1.5,
        });
      });
      this.highlightedFlowIndex = index;
      this.line[index].setOptions({
        dash: {
          animation: true,
        },
        size: 2,
      });
    },
    unHighlightLine(index) {
      this.line[index].setOptions({
        dash: false,
        size: 1.5,
      });
    },
    removeLine(index) {
      const scope = this;
      scope.shapes.map((shape) => {
        if (shape.id === scope.line[index].start.id) {
          if (scope.line[index].color === "#000") {
            let connections = shape.next.success.split(",");
            connections.splice(
              connections.indexOf(scope.line[index].end.id),
              1
            );
            shape.next.success = connections.join(",");
          } else {
            let connections = shape.next.failure.split(",");
            connections.splice(
              connections.indexOf(scope.line[index].end.id),
              1
            );
            shape.next.failure = connections.join(",");
          }
        }
      });
      scope.line[index].remove();
      scope.$emit("removeLine", index);
      scope.line.splice(index, 1);
      let lines = document.querySelectorAll(".leader-line");
      lines.forEach((line, index) => {
        line.addEventListener("click", () => {
          scope.highlightLine(index);
        });
      });
      scope.highlightedFlowIndex = -1;
    },
    returnZoom(val, step) {
      let returnval;
      if (this.zoomProperties.current.browser == "chrome") {
        returnval = `${this.zoomProperties.current.prefix}${val + step}${
          this.zoomProperties.current.suffix
        }`;
      }
      if (this.zoomProperties.current.browser == "firefox") {
        returnval = `${this.zoomProperties.current.prefix}${val + step}${
          this.zoomProperties.current.suffix
        }`;
      }

      return returnval;
    },
    returnZoom1(val, step) {
      let returnval;
      if (this.zoomProperties.current.browser == "chrome") {
        returnval = `${this.zoomProperties.current.prefix}${val + step}${
          this.zoomProperties.current.suffix
        }`;
      }
      if (this.zoomProperties.current.browser == "firefox") {
        returnval = `${this.zoomProperties.current.prefix}1${this.zoomProperties.current.suffix}`;
      }
      return returnval;
    },
    zoomIn() {
      // this function is used zoom in
      let div = document.querySelector("#div1");
      let zoom =
        document.querySelector("#div1").style[
          this.zoomProperties.current.property
        ];
      let lines = document.querySelectorAll(".leader-line");
      if (!zoom || zoom === "") {
        div.style["transform-origin"] = "left top";
        div.style[this.zoomProperties.current.property] = this.returnZoom(
          this.zoomProperties.current.zoom,
          0
        );
        if (lines) {
          lines.forEach((line) => {
            line.style[this.zoomProperties.current.property] = this.returnZoom(
              this.zoomProperties.current.zoom,
              0
            );
          });
        }
      }
      if (this.zoomProperties.current.zoom <= this.zoomProperties.current.max) {
        div.style["transform-origin"] = "left top";
        let zoomVal = this.returnZoom(
          this.zoomProperties.current.zoom,
          this.zoomProperties.current.step
        );
        let newZoom =
          this.zoomProperties.current.zoom + this.zoomProperties.current.step;
        this.handleZoom(div, lines, zoomVal, newZoom);
      }
    },
    zoomOut() {
      // this function is used zoom out
      let div = document.querySelector("#div1");
      let zoom =
        document.querySelector("#div1").style[
          this.zoomProperties.current.property
        ];
      let lines = document.querySelectorAll(".leader-line");
      if (!zoom || zoom === "") {
        div.style["transform-origin"] = "left top";
        div.style[this.zoomProperties.current.property] = this.returnZoom(
          this.zoomProperties.current.zoom,
          0
        );
        if (lines) {
          lines.forEach((line) => {
            line.style[this.zoomProperties.current.property] = this.returnZoom(
              this.zoomProperties.current.zoom,
              0
            );
          });
        }
      }
      if (this.zoomProperties.current.zoom >= this.zoomProperties.current.min) {
        div.style["transform-origin"] = "left top";
        var zoomVal = this.returnZoom(
          this.zoomProperties.current.zoom,
          this.zoomProperties.current.step * -1
        );
        let newZoom =
          this.zoomProperties.current.zoom - this.zoomProperties.current.step;
        this.handleZoom(div, lines, zoomVal, newZoom);
      }
    },
    handleZoom(div, lines, zoomVal, newZoom) {
      // this function is used handleZoom event this is main function in zoom
      div.style[this.zoomProperties.current.property] = zoomVal;
      if (lines) {
        lines.forEach((line) => {
          if (this.zoomProperties.current.browser == "chrome") {
            line.style[this.zoomProperties.current.property] = zoomVal;
          }
          if (this.zoomProperties.current.browser == "firefox") {
            line.style[this.zoomProperties.current.property] = this.returnZoom1(
              this.zoomProperties.current.zoom,
              0
            );
          }
        });
      }
      this.line.forEach((line) => {
        line.position();
      });
      this.zoomProperties.current.zoom = newZoom;
      this.snackbar = true;
    },
    showSnackBar(message) {
      var scope = this;
      scope.Snackbar.show = true;
      scope.Snackbar.text = message;
      setTimeout(() => {}, scope.Snackbar.timeout);
    },
    putJSON() {
      var scope = this;
      scope.generateJSON();
      const id = this.flow_id;
      const payload = { data: scope.flowJSON, flow_id: id };
      this.$store
        .dispatch("updateCallFlow", payload)
        .then((response) => {
          scope.isProcessing = false;
          if (response.data.statusCode === 200) {
            scope.showSnackBar("Updating...");
            scope.$router.push({ name: "CallFlow" });
          } else {
            scope.showSnackBar("Create error-" + response.message);
          }
        })
        .catch(function () {
          scope.isProcessing = false;
          scope.showSnackBar("Error Creating Tag");
        });
    },
    generateJSON() {
      let values = {};
      const flows = this.shapes.slice(1);
      for (var i = 0; i < flows.length; i++) {
        var id = flows[i].id;
        values[id] = flows[i];
      }
      const connections = this.line.map((line) => {
        return {
          end: line.end.id,
          start: line.start.id,
        };
      });
      const variable = this.variables;
      const json = {
        data: {
          start: {
            ...this.shapes[0],
            flowType: "start",
          },
          values,
          connections,
          variable
        },
      };
      this.flowJSON = json;
      this.$store.dispatch("updateJSON", json);
    },
    addMenuSettings(settings, index) {
      let length = settings[settings.length - 1].id + 1;
      this.shapes[index].settings.push({
        id: length,
        value: `${length + 1}`,
        action: "",
      });
    },
    removeMenuSettings(footer, index) {
      this.shapes[footer].settings.splice(index, 1);
    },
    // dragEnd(x, y) {
    // this.shapes[this.activatedIndex].x = x;
    // this.shapes[this.activatedIndex].y = y;
    // }
  },
  // updated() {
  //     if (this.lines.length > 0) {
  //         this.lines.forEach(line => {
  //             const id = line.end.id.split("-")[1];
  //             if (id != this.flow.name) {
  //                 line.hide();
  //             } else {
  //                 line.show();
  //             }
  //         });
  //     }
  // },
  watch: {
    showJSON(val) {
      this.showJSONComponent = val;
      if (val) {
        this.generateJSON();
      }
    },
  },
  computed: {
    ...mapGetters(["getJSON", "updateJSON"]),
    zoomalert() {
      return (
        this.zoomProperties.current.zoom * this.zoomProperties.current.unit +
        "%"
      );
    },
    dialVariables() {
      let temp = ["DID Number", "Caller", "Agent"];
      return this.variables.filter((e) => {
        return !temp.includes(e);
      });
    },
  },
  beforeDestroy() {
    this.line.forEach((item) => {
      item.remove();
    });
  },
};
</script>
<style>
body {
  overflow: hidden;
}

body .leader-line {
  pointer-events: auto !important;
}

.header {
  border-width: 1px 0 1px;
  border-style: solid;
}

.hover {
  border: 1.5px solid red;
}

.controls {
  position: fixed;
  display: flex;
  bottom: 10px;
  right: 0px;
}

.controls i {
  display: block;
  color: #fff !important;
  background: #424242;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  text-align: center;
  padding: 10px 0;
  margin: 10px 0;
}

.zoom-in,
.zoom-out {
  top: 90%;
  width: 40px !important;
  height: 40px !important;
  min-width: 40px;
}

.zoom-in {
  right: 30px;
}

.zoom-out {
  right: 80px;
}

.flow {
  box-shadow: 1px 1px 13px #999;
  position: absolute;
  border-radius: 5px;
}

.draggable.resizable.flow.active,
.check.highlight {
  box-shadow: 1px 1px 14px #666;
}

.check.highlight > .custom-handle {
  display: block !important;
}
</style>
